import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { fetchCountryIfNeeded } from '../actions/CountryActions';
import { fetchOffersIfNeeded } from '../actions/OfferActions';
import { languagePlainSelector, offersSelector } from '../selectors';
import { useAppDispatch } from './useAppDispatch';
import { NOOP } from '../utils';
export function useExplorationQuests(platform) {
    var dispatch = useAppDispatch();
    var language = useSelector(languagePlainSelector);
    var quests = useSelector(offersSelector);
    useEffect(function () {
        dispatch(fetchCountryIfNeeded())
            .then(function (country) {
            if (country) {
                dispatch(fetchOffersIfNeeded({ platform: platform, country: country })).catch(NOOP);
            }
        })
            .catch(NOOP);
    }, [language, dispatch, platform]);
    return quests;
}
